document.addEventListener("DOMContentLoaded", function () {
  const sliderInstances = new WeakMap(); // 各スライダー管理

  function initSliders() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const elms = document.getElementsByClassName('splide');

    for (let i = 0; i < elms.length; i++) {
      const sliderEl = elms[i];
      const instance = sliderInstances.get(sliderEl);

      if (isMobile && !instance) {
        // モバイル時: Splideを初期化
        const splide = new Splide(sliderEl, {
          type: 'loop',
          perPage: 1,
          autoplay: true,
          interval: 10000,
          speed: 1000,
          pauseOnHover: false,
          arrows: true,
          pagination: false,
          gap: '20px',
        });

        splide.mount();
        sliderInstances.set(sliderEl, splide);

      } else if (!isMobile && instance) {
        // PC時: Splideを破棄（無効化）
        instance.destroy(true);
        sliderInstances.delete(sliderEl);
      }
    }
  }

  // 初期化
  initSliders();
  // 画面リサイズ時もチェック
  window.addEventListener("resize", initSliders);
});
